















import { Component, Vue } from 'vue-property-decorator'
import Card from '@/components/history/Card.vue'
@Component({
  components: {
    Card
  }
})
export default class History extends Vue {}
